import React, { useState } from "react";
import { Outlet } from "react-router";
import styles from "./Banner.module.scss";
import { useHeroBanner } from "../../contexts/HeroBannerContext";

const Banner: React.FC = () => {
  const [desktopLoaded, setDesktopLoaded] = useState(false);
  const [tabletLoaded, setTabletLoaded] = useState(false);
  const [mobileLoaded, setMobileLoaded] = useState(false);
  const { hasHeroBanner } = useHeroBanner();

  // Hide static banner if hero banner exists
  if (hasHeroBanner) {
    return <Outlet />;
  }

  return (
    <>
      {/* Desktop Banner */}
      <div className={`${styles["banner"]} is-hidden-touch`} style={{ position: 'relative' }}>
        {!desktopLoaded && (
          <div className={styles.skeletonBanner} style={{ height: 450 }} />
        )}
        <img
          src={process.env.PUBLIC_URL + "/images/banner/Store.png"}
          alt="feeds-background"
          style={desktopLoaded ? {} : { display: 'none' }}
          onLoad={() => setDesktopLoaded(true)}
        />
      </div>

      {/* Tablet Banner */}
      <div className={`${styles["banner"]} is-hidden-mobile is-hidden-desktop`} style={{ position: 'relative' }}>
        {!tabletLoaded && (
          <div className={styles.skeletonBanner} style={{ height: '100%' }} />
        )}
        <img
          src={process.env.PUBLIC_URL + "/images/banner/HeroFeedTab.png"}
          alt="feeds-background"
          style={tabletLoaded ? {} : { display: 'none' }}
          onLoad={() => setTabletLoaded(true)}
        />
      </div>

      {/* Mobile Banner */}
      <div className={`${styles["banner"]} is-hidden-tablet is-hidden-desktop`} style={{ position: 'relative' }}>
        {!mobileLoaded && (
          <div className={styles.skeletonBanner} style={{ height: '100%' }} />
        )}
        <img
          src={process.env.PUBLIC_URL + "/images/banner/HeroFeedMobile.png"}
          alt="feeds-background"
          style={mobileLoaded ? {} : { display: 'none' }}
          onLoad={() => setMobileLoaded(true)}
        />
      </div>

      <Outlet />
    </>
  );
};

export default Banner;
